export default __webpack_public_path__ + "4ab7459b32cf457c666cd1c0abdc8999.png";